import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "../../core/Logger.js";
import { isUint16Array as t, isUint32Array as i } from "../../core/typedArrayUtil.js";
import { checkWebGLError as s } from "./checkWebGLError.js";
import { ResourceType as r } from "./enums.js";
var n = e.getLogger("esri.views.webgl.BufferObject");

var o = /*#__PURE__*/function () {
  function o(e, t, i, n, _o) {
    _classCallCheck(this, o);

    this._context = e, this.bufferType = t, this.usage = i, this._glName = null, this._size = -1, this._indexType = void 0, e.instanceCounter.increment(r.Buffer, this), this._glName = this._context.gl.createBuffer(), s(this._context.gl), n && this.setData(n, _o);
  }

  _createClass(o, [{
    key: "glName",
    get: function get() {
      return this._glName;
    }
  }, {
    key: "size",
    get: function get() {
      return this._size;
    }
  }, {
    key: "indexType",
    get: function get() {
      return this._indexType;
    }
  }, {
    key: "byteSize",
    get: function get() {
      return 34962 === this.bufferType ? this._size : 5125 === this._indexType ? 4 * this._size : 2 * this._size;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      var e;

      if (null != (e = this._context) && e.gl) {
        if (this._glName) {
          this._context.gl.deleteBuffer(this._glName), this._glName = null;
        }

        this._context.instanceCounter.decrement(r.Buffer, this), this._context = null;
      } else this._glName && n.warn("Leaked WebGL buffer object");
    }
  }, {
    key: "setData",
    value: function setData(e, r) {
      if (!e) return;

      if ("number" == typeof e) {
        if (e < 0 && n.error("Buffer size cannot be negative!"), this._size = e, 34963 === this.bufferType && r) switch (this._indexType = r, this._size = e, r) {
          case 5123:
            e *= 2;
            break;

          case 5125:
            e *= 4;
        }
      } else {
        var _s = e.byteLength;
        t(e) && (_s /= 2, this._indexType = 5123), i(e) && (_s /= 4, this._indexType = 5125), this._size = _s;
      }

      var _o2 = this._context.getBoundVAO();

      this._context.bindVAO(null), this._context.bindBuffer(this);
      var h = this._context.gl;
      h.bufferData(this.bufferType, e, this.usage), s(h), this._context.bindVAO(_o2);
    }
  }, {
    key: "setSubData",
    value: function setSubData(e) {
      var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var _o3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      var h = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : e.byteLength;
      if (!e) return;
      (r < 0 || r >= this._size) && n.error("offset is out of range!");
      var f = r,
          u = _o3,
          a = h,
          c = e.byteLength;
      t(e) ? (c /= 2, f *= 2, u *= 2, a *= 2) : i(e) && (c /= 4, f *= 4, u *= 4, a *= 4), void 0 === h && (h = c - 1), _o3 >= h && n.error("end must be bigger than start!"), r + _o3 - h > this._size && n.error("An attempt to write beyond the end of the buffer!");

      var _ = this._context.getBoundVAO();

      this._context.bindVAO(null), this._context.bindBuffer(this);
      var b = this._context.gl,
          g = ArrayBuffer.isView(e) ? e.buffer : e,
          l = 0 === u && a === e.byteLength ? g : g.slice(u, a);
      b.bufferSubData(this.bufferType, f, l), s(b), this._context.bindVAO(_);
    }
  }, {
    key: "setSubDataFromView",
    value: function setSubDataFromView(e, t, i, r) {
      if (!e) return;
      (t < 0 || t >= this._size) && n.error("offset is out of range!"), i >= r && n.error("end must be bigger than start!"), t + i - r > this._size && n.error("An attempt to write beyond the end of the buffer!");

      var _o4 = this._context.getBoundVAO();

      this._context.bindVAO(null), this._context.bindBuffer(this);
      var h = this._context.gl,
          f = 0 === i && r === e.length ? e : e.subarray(i, r);
      h.bufferSubData(this.bufferType, t * e.BYTES_PER_ELEMENT, f), s(h), this._context.bindVAO(_o4);
    }
  }], [{
    key: "createIndex",
    value: function createIndex(e, t, i, s) {
      return new o(e, 34963, t, i, s);
    }
  }, {
    key: "createVertex",
    value: function createVertex(e, t, i) {
      return new o(e, 34962, t, i);
    }
  }]);

  return o;
}();

export { o as default };